var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('form-fields',{attrs:{"item":_vm.item,"lessonId":_vm.lessonId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }